export default __webpack_public_path__ + "static/media/04.744b2842.jpg";